<template>
    <div class="address-form">
        <!-- Forms -->
        <form>
            <y-row class="pt-4 ma-0 justify-content-center">
                <y-row class="ma-0">
                    <y-col
                        sm="6"
                        class="mb-10"
                    >
                        <y-input
                            v-model="model.title"
                            :placeholder="$t('profileAddressEditor.forms.title')"
                            :label="$t('profileAddressEditor.forms.title')"
                            name="title"
                            validation="required"
                        />
                    </y-col>
                    <y-col
                        sm="6"
                        class="mb-10"
                    >
                        <y-input
                            v-model="model.contact_name"
                            :placeholder="$t('profileAddressEditor.forms.contact_name')"
                            :label="$t('profileAddressEditor.forms.contact_name')"
                            name="contact_name"
                            validation="required"
                        />
                    </y-col>

                    <!-- TODO: change division fields after refactoring division component -->
                    <y-col
                        sm="6"
                        class="mb-10"
                    >
                        <y-select
                            :init="address.division.province"
                            :placeholder="$t('profileAddressEditor.forms.province')"
                            :label="$t('profileAddressEditor.forms.province')"
                            :options="divisions.province"
                            name="province"
                            @input="selectedDiv($event, 'province', 'city')"
                        />
                    </y-col>
                    <y-col
                        sm="6"
                        class="mb-10"
                    >
                        <y-select
                            :init="address.division.city"
                            :placeholder="$t('profileAddressEditor.forms.city')"
                            :label="$t('profileAddressEditor.forms.city')"
                            :disable="!model.division.province"
                            :options="divisions.city"
                            name="city"
                            @input="selectedDiv($event, 'city')"
                        />
                    </y-col>

                    <y-col
                        sm="4"
                        class="mb-10"
                    >
                        <y-input
                            v-model="model.postal_code"
                            class="d-block number-type"
                            :placeholder="$t('profileAddressEditor.forms.postal_code')"
                            :label="$t('profileAddressEditor.forms.postal_code')"
                            name="postal_code"
                            format="DDDDD-DDDDD"
                            dir="ltr"
                        />
                    </y-col>
                    <y-col
                        sm="4"
                        class="mb-10"
                    >
                        <y-input
                            v-model="model.mobile"
                            class="number-type"
                            :placeholder="$t('profileAddressEditor.forms.mobile')"
                            :label="$t('profileAddressEditor.forms.mobile')"
                            name="mobile"
                            format="(DDDD) DDD DDDD"
                            dir="ltr"
                        />
                    </y-col>
                    <y-col
                        sm="4"
                        class="mb-10"
                    >
                        <y-input
                            v-model="model.tel"
                            class="number-type"
                            :placeholder="$t('profileAddressEditor.forms.tel')"
                            :label="$t('profileAddressEditor.forms.tel')"
                            name="tel"
                            format="DDD DDDD DDDD"
                            dir="ltr"
                        />
                    </y-col>
                    <y-col
                        sm="12"
                        class="mb-10"
                    >
                        <y-textarea
                            v-model="model.address"
                            :placeholder="$t('profileAddressEditor.forms.address')"
                            :label="$t('profileAddressEditor.forms.address')"
                            name="address"
                            size="normal"
                            rows="8"
                        />
                    </y-col>
                    <y-col
                        sm="12"
                        class="mb-10"
                    >
                        <label
                            for="address"
                            class="y-field-wrapper__label mb-3 d-block"
                        >
                            {{ $t('profileAddressEditor.forms.map') }}
                        </label>
                        <y-select-map
                            v-model="mapLoc"
                            :element="mapElement"
                            @input="mapCoordinate($event)"
                        />
                    </y-col>
                </y-row>
            </y-row>
        </form>
    </div>
</template>

<script>
    import isEmpty from 'lodash.isempty';
    import {
        YSelectMap, YInput, YTextarea, YSelect,
    } from '@components';

    export default {
        name: 'AddressFormBlock',

        components: {
            YInput,
            YTextarea,
            YSelectMap,
            YSelect,
        },

        props: {
            /**
             * Address item
             */
            address: Object,

            /**
             * Division Config
             */
            divisionConfig: Object,
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                model: {
                    map_lat : '',
                    map_long: '',
                    division: {
                        province     : null,
                        city         : null,
                        neighbourhood: null,
                    },
                },
                map   : null,
                mapLoc: null,

                mapElement: {
                    center_lat: 0,
                    center_lng: 0,
                    height    : 400,
                    id        : 'addresses-map',
                    name      : 'location',
                },
                selectedDivs: {
                    province     : null,
                    city         : null,
                    neighbourhood: null,
                },
                divisions: {
                    province     : [],
                    city         : [],
                    neighbourhood: [],
                },
            };
        },

        watch: {
            address: {
                /**
                 * Set address value
                 *
                 * @param {object}newVal
                 * @param {object}oldVal
                 */
                handler(newVal, oldVal) {
                    if (!this.isEqual(oldVal, newVal)) {
                        this.$set(this.model, 'title', newVal.title);
                        this.$set(this.model, 'contact_name', newVal.contact_name);
                        this.$set(this.model, 'tel', newVal.tel);
                        this.$set(this.model, 'mobile', newVal.mobile);
                        this.$set(this.model, 'postal_code', newVal.postal_code);
                        this.$set(this.model, 'address', newVal.address);
                        this.mapLoc = newVal.map;
                    }
                },
                deep     : true,
                immediate: true,
            },

            model: {
                /**
                 * Watch locales to clear extra data
                 */
                handler() {
                    this.$emit('input', this.model);
                },
                deep: true,
            },
        },

        /**
         * @inheritdoc
         */
        created() {
            this.fetchDivision('province', this.$store.getters['division/division'].country);
            if (this.address.division.province) {
                this.fetchDivision('city', this.address.division.province);
            }
            if (this.address.division.city) {
                this.fetchDivision('neighbourhood', this.address.division.city);
            }

            if (this.address) {
                this.$set(this.model, 'division', this.address.division);
            }
        },

        methods: {
            isEmpty,

            /**
             * Get Map Coordinate
             *
             * @param {*}e
             */
            mapCoordinate(e) {
                const latitude = e.lat.toFixed(6);
                const longitude = e.long.toFixed(6);
                this.model.map_lat = latitude.toString();
                this.model.map_long = longitude.toString();
            },

            /**
             * Fetch Division
             *
             * @param {string} type
             * @param {string} parentId
             * @returns {*}
             */
            fetchDivision(type, parentId) {
                this.$wait.start('address-division');
                const paramKey = {
                    province     : 'countries_id',
                    city         : 'provinces_id',
                    neighbourhood: 'cities_id',
                };
                const filter = { [paramKey[type]]: [parentId] };

                const params = {
                    types    : [type],
                    sort     : `title_${this.$i18n.locale}`,
                    order    : 'asc',
                    including: [
                        'id',
                        `title_${this.$i18n.locale}`,
                    ],
                    ...filter,
                };
                const titleLocale = `title_${this.$i18n.locale}`;
                return this.$services.list('division', params).then((response) => {
                    const options = response.data.results.map((item) => ({
                        value: item.id,
                        label: item[titleLocale],
                    }));
                    this.$set(this.divisions, `${type}`, options);
                }).catch((error) => {
                    this.$wait.end('address-division');
                    this.handleError(error);
                });
            },

            /**
             * Selected Div
             *
             * @param {*} e - Id of the selected div
             * @param {*} type - Type of the current div
             * @param {*} next - Type of the next div
             */
            selectedDiv(e, type, next) {
                if (e !== this.model.division[type]) {
                    this.$set(this.model.division, `${type}`, e);
                    this.$set(this.model.division, `${next}`, null);
                    this.$set(this.divisions, `${next}`, []);
                    if (next) {
                        this.fetchDivision(next, e);
                    }
                }
            },
        },
    };
</script>
